var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGlobeBigCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#0033AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3338 27.2632C21.1397 21.2442 25.5949 14.8798 31.9997 14.8798C38.404 14.8798 42.8598 21.2438 40.6656 27.2602C40.6655 27.2603 40.6655 27.2603 40.6655 27.2604L33.0476 48.1549L30.9518 48.1549L23.3338 27.2633L23.3338 27.2632ZM25.4296 26.4991C25.4296 26.4991 25.4296 26.4991 25.4296 26.4992L31.9996 44.5168L38.5698 26.496C40.2331 21.9357 36.8561 17.1105 31.9997 17.1105C27.1437 17.1105 23.766 21.9354 25.4296 26.4991Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9998 20.8894C30.5255 20.8894 29.3304 22.0846 29.3304 23.5589C29.3304 25.0332 30.5255 26.2283 31.9998 26.2283C33.4741 26.2283 34.6693 25.0332 34.6693 23.5589C34.6693 22.0846 33.4741 20.8894 31.9998 20.8894ZM27.0996 23.5589C27.0996 20.8526 29.2935 18.6587 31.9998 18.6587C34.7061 18.6587 36.9 20.8526 36.9 23.5589C36.9 26.2652 34.7061 28.4591 31.9998 28.4591C29.2935 28.4591 27.0996 26.2652 27.0996 23.5589Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGlobeBigCircle);
export default __webpack_public_path__ + "static/media/ic_globe_big_circle.869f5569bd88baaa29bc7df4d9401751.svg";
export { ForwardRef as ReactComponent };